import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  fetchContactSubmissions,
  updateContactStatus,
  deleteContactSubmission,
} from '../services/api'

export function useContactSubmissions(status: 'unread' | 'read' | 'responded' | 'all' = 'unread') {
  return useQuery({
    queryKey: ['admin-contact', status],
    queryFn: () => fetchContactSubmissions(status),
    staleTime: 0,
    refetchOnWindowFocus: true,
  })
}

export function useUpdateContactStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: 'unread' | 'read' | 'responded' }) =>
      updateContactStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-contact'] })
    },
  })
}

export function useDeleteContactSubmission() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => deleteContactSubmission(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-contact'] })
    },
  })
}
